
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Urbaniaonrentinpune() {



    const cardData =
    {
        keyword: ' Urbania On Rent in Pune',
        heading: 'Mauli Cabs:  Urbania On Rent in Pune ',
        headingDescription: 'Mauli Cabs offers spacious and luxurious Urbania on rent in Pune, providing an ideal solution for group travel, events, and corporate outings. With a focus on comfort and style, our well-maintained Urbania vehicles are equipped to accommodate large groups while ensuring a smooth and enjoyable ride. Whether you are planning a family trip, a wedding event, or a business excursion, our professional drivers, transparent pricing, no hidden charges, and commitment to punctuality and customer satisfaction make Mauli Cabs the perfect choice for your travel needs.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Luxury Force Urbania On Rent in Pune",
      "description": "Rent a luxury Force Urbania in Pune for corporate travel, outstation trips, or group tours. Equipped with push-back seats, AC, entertainment systems, and ample legroom for a premium ride."
    },
    {
      "name": "13 Seater Force Urbania On Rent in Pune",
      "description": "Hire a 13-seater Force Urbania in Pune for mid-size groups. Ideal for family outings, team travel, and city-to-city transfers with comfort and safety."
    },
    {
      "name": "17 Seater Force Urbania On Rent in Pune",
      "description": "Get a 17-seater Force Urbania on rent in Pune for long-distance travel, corporate events, or religious trips. Spacious interiors and excellent suspension ensure a smooth journey."
    },
    {
      "name": "Force Urbania for Rent in Pune",
      "description": "Book Force Urbania vans in Pune for group travel, events, or airport transfers. Available in various configurations with professional drivers and competitive pricing."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania Bus on Rent",
      "description": "Rent a Force Urbania bus from Pune to Mahabaleshwar. Ideal for weekend getaways with friends or family, offering a relaxing and scenic drive."
    },
    {
      "name": "Pune to Shirdi Urbania on Rent",
      "description": "Comfortable Urbania vans on rent from Pune to Shirdi. A safe and spiritual travel option with fixed pricing and well-maintained vehicles."
    },
    {
      "name": "Pune to Mumbai International Airport Urbania on Rent",
      "description": "Hire a Force Urbania for airport transfer from Pune to Mumbai International Airport. Spacious luggage capacity, AC, and on-time pickup guaranteed."
    },
    {
      "name": "Pune to Lonavala Urbania on Rent",
      "description": "Enjoy a smooth ride to Lonavala in a Force Urbania from Pune. Ideal for weekend picnics and day trips with friends or colleagues."
    },
    {
      "name": "Pune to Kolhapur Urbania Hire",
      "description": "Hire a Force Urbania van from Pune to Kolhapur for pilgrimage, business, or leisure travel. Comfortable, efficient, and safe for long-distance trips."
    },
    {
      "name": "Urbania on Rent in Pimpri Chinchwad",
      "description": "Get Force Urbania vans on rent in Pimpri Chinchwad for local or outstation travel. Reliable service with well-maintained vehicles and courteous drivers."
    },
    {
      "name": "Urbania on Rent in Koregaon Park Pune",
      "description": "Book Force Urbania rentals in Koregaon Park for corporate teams, tourist groups, or wedding events. Prompt pickup and premium features included."
    },
    {
      "name": "Urbania on Rent in Hadapsar",
      "description": "Hadapsar-based Force Urbania rentals for local travel, weekend tours, or outstation trips. On-demand booking with flexible rental durations."
    },
    {
      "name": "Urbania on Rent in Kharadi Pune",
      "description": "Hire Urbania vans from Kharadi for business or leisure trips. Comfort-focused interiors and expert drivers ensure a great travel experience."
    },
    {
      "name": "Urbania on Rent in Kothrud Pune",
      "description": "Get a Force Urbania on rent in Kothrud, Pune. Ideal for group excursions, temple tours, or employee transportation with seamless service."
    },
    {
      "name": "Force Urbania on Rent in Viman Nagar",
      "description": "Rent Urbania vans from Viman Nagar for quick airport transfers, weekend escapes, or city tours. Comfortable, AC vans with trained chauffeurs."
    },
    {
      "name": "Force Urbania on Rent in Wagholi Pune",
      "description": "Book a Force Urbania from Wagholi for corporate travel, family outings, or intercity trips. Available with fixed and per-km pricing."
    },
    {
      "name": "Pune to Nashik Urbania on Rent",
      "description": "Hire a Force Urbania from Pune to Nashik for group travel or wine tours. AC comfort, reliable pickup, and transparent rates included."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Urbania on Rent",
      "description": "Go on the Ashtavinayak Darshan with our Force Urbania rentals from Pune. Covers all 8 temples with flexible routing and experienced drivers."
    },
    {
      "name": "Luxury Force Urbania on Rent in Pune Hadapsar",
      "description": "Luxury Urbania van available on rent in Hadapsar, Pune. Ideal for high-comfort family tours or executive outings with elite interiors and features."
    },
    {
      "name": "Luxury Force Urbania on Rent in Hinjewadi",
      "description": "Premium Urbania rentals from Hinjewadi, perfect for business executives and team travel. On-time pickup and a first-class travel experience guaranteed."
    },
    {
      "name": "Luxury Force Urbania on Rent in Hinjewadi Near Me",
      "description": "Find and book luxury Force Urbania vans in Hinjewadi near your location. Ideal for both corporate and leisure travel with elite features."
    },
    {
      "name": "Pune to Goa Urbania Bus on Rent",
      "description": "Travel in style from Pune to Goa in a Force Urbania bus. AC comfort, scenic route options, and professional service for group trips."
    }
  ],
  "tableData": [
    ["Luxury Force Urbania On Rent in Pune", "13 Seater Force Urbania On Rent in Pune"],
    ["17 Seater Force Urbania On Rent in Pune", "Force Urbania for Rent in Pune"],
    ["Pune to Mahabaleshwar Urbania Bus on Rent", "Pune to Shirdi Urbania on Rent"],
    ["Pune to Mumbai International Airport Urbania on Rent", "Pune to Lonavala Urbania on Rent"],
    ["Pune to Kolhapur Urbania Hire", "Urbania on Rent in Pimpri Chinchwad"],
    ["Urbania on Rent in Koregaon Park Pune", "Urbania on Rent in Hadapsar"],
    ["Urbania on Rent in Kharadi Pune", "Urbania on Rent in Kothrud Pune"],
    ["Force Urbania on Rent in Viman Nagar", "Force Urbania on Rent in Wagholi Pune"],
    ["Pune to Nashik Urbania on Rent", "Pune to Ashtavinayak Darshan Urbania on Rent"],
    ["Luxury Force Urbania on Rent in Pune Hadapsar", "Luxury Force Urbania on Rent in Hinjewadi"],
    ["Luxury Force Urbania on Rent in Hinjewadi Near Me", "Pune to Goa Urbania Bus on Rent"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Spacious and Comfortable Ride",
        "WhyChoosedescription": "Mauli Cabs offers the Urbania on rent in Pune, providing a premium, spacious, and comfortable ride for your group travels. With ample seating and luxurious interiors, it’s perfect for family outings, corporate events, or weddings."
    },
    {
        "WhyChooseheading": "Ideal for Group Travel",
        "WhyChoosedescription": "The Urbania is designed to accommodate large groups, making it an ideal choice for trips with family, friends, or colleagues. With seating for up to 13 people, you’ll travel together in comfort and style."
    },
    {
        "WhyChooseheading": "Modern and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our Urbania vehicles are new, well-maintained, and equipped with all modern amenities like air-conditioning, comfortable seating, and a smooth ride. Enjoy a luxurious experience throughout your journey."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Whether you need an Urbania for a few hours, a full day, or even for outstation travel, Mauli Cabs offers flexible rental packages to suit your schedule and budget."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Costs",
        "WhyChoosedescription": "Enjoy transparent pricing with no hidden charges. Our rental packages are affordable and designed to provide excellent value, so you can enjoy a luxury ride without breaking the bank."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly trained and experienced in handling group travel. They ensure a safe, smooth, and enjoyable journey while making sure all your needs are met during the trip."
    },
    {
        "WhyChooseheading": "Perfect for Special Occasions",
        "WhyChoosedescription": "Planning a wedding, corporate retreat, or any special event? The Urbania is the perfect vehicle to ensure your guests travel together in comfort and style. Make your occasion even more memorable with a premium ride."
    },
    {
        "WhyChooseheading": "24/7 Availability and Customer Support",
        "WhyChoosedescription": "Mauli Cabs offers 24/7 booking services for Urbania rentals in Pune. You can easily book through our website or app, and our support team is always available to assist with any questions or changes to your booking."
    }
]






















    }


    const faqData = [
        {
            question: 'How do I book an Urbania on rent in Pune with Mauli Cabs?',
            answer: 'Booking a Force Urbania in Pune with Mauli Cabs is easy. Just visit our website or mobile app, select "Urbania" under vehicle type, enter your travel details, and confirm your booking. You can also call our customer support team for assistance with group or corporate bookings.',
        },
        {
            question: 'What are the seating options available in Urbania?',
            answer: 'Our Force Urbania rentals typically come in 13-seater, 17-seater, and 20-seater options. Each variant offers spacious seating, push-back seats, and ample legroom—ideal for both long trips and group travel.',
        },
        {
            question: 'Is Urbania available for local and outstation trips?',
            answer: 'Yes, Urbania is available for both local travel within Pune as well as outstation trips to destinations like Goa, Mahabaleshwar, Lonavala, and Shirdi. It’s ideal for family tours, corporate outings, and pilgrimages.',
        },
        {
            question: 'What amenities are included in the Urbania rental?',
            answer: 'Urbania vehicles come with air conditioning, push-back luxury seats, mobile charging points, ample luggage space, and clean interiors for a comfortable and premium travel experience.',
        },
        {
            question: 'Are rental charges for Urbania fixed or flexible?',
            answer: 'Mauli Cabs offers competitive, fixed pricing based on kilometers, trip duration, and seating capacity. Our rental includes driver charges and fuel. No hidden charges are applied.',
        },
        {
            question: 'Can I rent Urbania for events like weddings or corporate travel?',
            answer: 'Yes, Urbania is perfect for events like weddings, corporate functions, team outings, school or college tours, and large family trips. We can help customize the rental according to your needs.',
        },
        {
            question: 'Are Mauli Cabs drivers trained for Urbania long-distance trips?',
            answer: 'Yes, our drivers are experienced in handling Urbania vehicles and are well-trained for both city and long-distance highway travel. Safety, punctuality, and comfort are our top priorities.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sameer Chavan",
            position: "Corporate HR Manager",
            text: "We booked a 17-seater Urbania for a corporate retreat from Pune to Lonavala. The vehicle was modern, spacious, and extremely comfortable. Everyone appreciated the smooth ride and timely service by Mauli Cabs.",
            image: "/img/testimonial/testimonial-thumb-1-13.png",
        },
        {
            name: "Mrs. Leena Joshi",
            position: "Family Group Leader",
            text: "Mauli Cabs provided an Urbania for our family trip to Shirdi. The booking process was easy, the driver was courteous, and the vehicle was in excellent condition. A great option for large group travel!",
            image: "/img/testimonial/testimonial-thumb-1-14.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Urbania On Rent in Pune by Mauli Cabs",
        "description": "Mauli Cabs offers luxury Force Urbania vans for rent in Pune. Choose from 13-seater and 17-seater Urbania options for outstation trips, airport transfers, and city travel. Available across Hadapsar, Hinjewadi, Kharadi, Viman Nagar, and more. Book your comfortable journey online now.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "4100"
        }
      };
      

      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Urbania on Rent in Pune | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Hire luxury Force Urbania vans in Pune with Mauli Cabs. Book 13 or 17-seater Urbania for trips to Mumbai, Goa, Mahabaleshwar, Shirdi, Nashik, and more. Available in Hinjewadi, Hadapsar, Kharadi, and all major Pune locations."
        />
        <meta
          name="keywords"
          content="Luxury Force Urbania On Rent in Pune, 13 seater force urbania on rent in pune, 17 Seater force Urbania On Rent in Pune, force urbania for rent in pune, pune to mahabaleshwar urbania bus on rent, pune to shirdi urbania on Rent, pune to mumbai international airport urbania on rent, pune to lonavala urbania on rent, pune to kolhapur urbania hire, urbania on rent in pimpri chinchwad, urbania on rent in koregaon park pune, urbania on rent in hadapsar, Urbania on rent in kharadi pune, urbania on rent in kothrud pune, force urbania on rent in viman nagar, force urbania on rent in wagholi pune, pune to nashik urbania on rent, pune to ashtavinayak darshan urbania on rent, Luxury force urbania on rent in pune hadapsar, luxury force urbania on rent in hinjewadi, Luxury force urbania on rent in hinjewadi near me, Pune to Goa Urbania bus on Rent"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpune;